var exports = {
  "qM": "AttachmentSingleMedia.module__relativeWrapper___SzBYV0",
  "u7": "AttachmentSingleMedia.module__singleMediaContainer___SzBYV0",
};

module.exports = exports;
